export default (collapseFunction, openFunction, threshold) => {
  let currentPixel = window.pageYOffset;
  let scrollTime = 0;
  const looper = () => {
    const newPixel = window.pageYOffset;
    const diff = newPixel - currentPixel;
    const speed = diff * 1.125;
    if (speed > diff) {
      scrollTime = scrollTime + 1;
      if (scrollTime === threshold) {
        collapseFunction();
      }
    } else if (speed < diff) {
      scrollTime = scrollTime + 1;
      if (scrollTime === threshold) {
        openFunction();
      }
    } else {
      scrollTime = 0;
    }
    currentPixel = newPixel;
    requestAnimationFrame(looper);
  };
  looper();
};



// WEBPACK FOOTER //
// ./src/scripts/scrollWatcher.js